import {
  GREY_400,
  GREY_500,
  GREY_600,
  GREY_700,
  GREY_800,
  GREY_900,
} from '@mnd-frontend/ui/shared/tokens';
import { color, type HSLColor, hsl } from 'd3-color';

const greys = [GREY_400, GREY_500, GREY_600, GREY_700, GREY_800, GREY_900];

const hexToHSL = (hex: string) => {
  const c = color(hex);
  if (!c) {
    throw new Error(`Invalid color: ${hex}`);
  }
  return hsl(c) as HSLColor;
};
const colorizeGrey = (grey: HSLColor, baseColor: HSLColor, saturationFactor: number) => {
  return hsl(baseColor.h, baseColor.s * saturationFactor, grey.l);
};
/*
  This will return an array of colors that can be used in a graph.
  Starting with the greys, and if more colors are needed 
  it will add colors that are more saturated versions of the greys.
*/
export const getGraphColors = (baseColor: string, count: number) => {
  if (count <= greys.length) {
    return greys.slice(0, count);
  }
  const baseColorHSL = hexToHSL(baseColor);
  const extraColors = count - greys.length;
  const minSaturation = 0.15;
  const maxSaturation = 0.65;
  const saturationIncrement = (maxSaturation - minSaturation) / extraColors;

  const colors = [...greys];
  for (let i = 0; i < extraColors; i++) {
    const grey = hexToHSL(greys[i % greys.length]);
    const saturationFactor = minSaturation + i * saturationIncrement;
    colors.push(colorizeGrey(grey, baseColorHSL, saturationFactor).formatHex());
  }
  return colors;
};
